import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=13c9d2f4&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangePassword.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&id=13c9d2f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c9d2f4",
  null
  
)

export default component.exports